export const BLACK = `#000000`;
export const WHITE = `#FFFFFF`;
export const YELLOW = `#FFB600`;
export const DARK_GRAY = `#232122`;
export const GREIGE = `#938B8B`;
export const PAPER = `#EFEAEA`;
export const RED = `#A30000`;
export const LIGHT_GREY = `#D3CDCD`;
